import { apiSlice } from './apiSlice'

export interface AgentPlanActionsRequest {
  message: string
  activeModule: string | null
}

export const agentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    planAgentActions: builder.mutation<unknown, AgentPlanActionsRequest>({
      query: (body) => ({
        url: '/agent-chat/plan-actions',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { usePlanAgentActionsMutation } = agentApi

